import { DateTime } from 'luxon';
import { DATE_TIME_UNITS } from 'common/constants';
import { OpenGlCalendarsType } from 'pages/VendorsTablePage/components/PrintChecks/types';

export const getAccountingDateRange = (
  dates?: OpenGlCalendarsType
): [Date, Date] | [] => [
  DateTime.fromISO(dates?.currentStart ?? '')
    .minus({ days: 1 })
    .toJSDate(),
  DateTime.fromISO(dates?.postaheadStart ?? '')
    .endOf(DATE_TIME_UNITS.MONTH)
    .plus({ days: 1 })
    .toJSDate()
];
